module.exports = __webpack_public_path__ + "static/img/test3.dbbe693.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/product/test3.png
// module id = F5vi
// module chunks = 1